namespace RedBullMOBILE360.CustomerCare {
    export namespace ThreeThreeZeroNotificationService {
        export const baseUrl = 'CustomerCare/ThreeThreeZeroNotification';

        export declare function Create(request: Serenity.SaveRequest<ThreeThreeZeroNotificationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ThreeThreeZeroNotificationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ThreeThreeZeroNotificationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ThreeThreeZeroNotificationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: FraudNumbersExcelFile, onSuccess?: (response: Serenity.Extensions.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomerCare/ThreeThreeZeroNotification/Create",
            Update = "CustomerCare/ThreeThreeZeroNotification/Update",
            Delete = "CustomerCare/ThreeThreeZeroNotification/Delete",
            Retrieve = "CustomerCare/ThreeThreeZeroNotification/Retrieve",
            List = "CustomerCare/ThreeThreeZeroNotification/List",
            ExcelImport = "CustomerCare/ThreeThreeZeroNotification/ExcelImport"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ExcelImport'
        ].forEach(x => {
            (<any>ThreeThreeZeroNotificationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
